import TomSelect from "tom-select";

$(document).on("turbo:load", function () {
  if (document.querySelector(".tom-select")) {
    document.querySelectorAll(".tom-select").forEach((el) => {
      new TomSelect(el, {
        plugins: {
          remove_button: {
            title: "Remove this item"
          }
        },
        persist: false,
        create: false
      });
    });
    document.querySelectorAll(".tom-select").forEach((el) => {
      el.classList.remove("form-control");
    });
  }
});
